import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { Grid, Link } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';

export const FinancedOfferItemComponentSummary = ({ t, financedOffer, openFinancedOffer }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant='subtitle2' color='primary'>
          {t('Folder.GeneralData.FinancedOffers.OfferNumber')}
          <Link style={{ cursor: 'pointer' }} onClick={openFinancedOffer(financedOffer.offerId, financedOffer.offerSiteId)}>
            {financedOffer.documentNumber}
          </Link>
          {' / ' +
            financedOffer.offerStateName +
            ' / ' +
            t('DATE_FORMAT', { date: { value: financedOffer.offerDate, format: 'DD.MM.YYYY' } })}
        </Typography>
      </Grid>
    </Grid>
  );
};

FinancedOfferItemComponentSummary.propTypes = {
  financedOffer: PropTypes.object.isRequired,
  openFinancedOffer: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default compose(withTranslation())(FinancedOfferItemComponentSummary);
